import { useState, useRef, useEffect } from 'react';

export default function SearchableSelect({
  options = [],
  value,
  onChange,
  placeholder = 'Selecionar...',
  required = false,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  const selected = options.find(o => o.value === value);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (opt) => {
    onChange(opt.value, opt);
    setOpen(false);
    setQuery('');
  };

  return (
    <div className="searchable-select" ref={ref}>
      <div
        className={`form-control d-flex align-items-center justify-content-between ${disabled ? 'bg-light' : ''}`}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer', userSelect: 'none' }}
        onClick={() => !disabled && setOpen(v => !v)}
      >
        <span style={{ color: selected ? 'inherit' : '#aaa' }}>
          {selected ? (
            <span className="d-flex align-items-center gap-2">
              {selected.icon && <span className={selected.iconColor}>{selected.icon}</span>}
              {selected.label}
            </span>
          ) : placeholder}
        </span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {required && !value && (
        <input
          tabIndex={-1}
          style={{ opacity: 0, height: 0, position: 'absolute' }}
          required
          value=""
          onChange={() => {}}
        />
      )}

      {open && (
        <div className="searchable-select-dropdown">
          <div style={{ padding: '6px 8px', borderBottom: '1px solid var(--cjc-gray-200)' }}>
            <input
              autoFocus
              className="form-control form-control-sm"
              placeholder="Buscar..."
              value={query}
              onChange={e => setQuery(e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          </div>
          {filtered.length === 0 ? (
            <div style={{ padding: '10px 12px', color: 'var(--cjc-gray-400)', fontSize: 13 }}>
              Nenhum resultado
            </div>
          ) : (
            filtered.map(opt => (
              <div
                key={opt.value}
                className={`searchable-select-option${opt.value === value ? ' selected' : ''}`}
                onClick={() => handleSelect(opt)}
              >
                {opt.icon && <span className={opt.iconColor}>{opt.icon}</span>}
                {opt.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
